import React from 'react';
import { PureComponent } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

class ComplementoSummaryActionButtons extends PureComponent {

  render() {
    const { onEdit, onDelete } = this.props;

    return (
      <Row className="pt-3">
        <Col>
          <Button variant="danger"
            className="mr-3"
            onClick={ onDelete }
          >
            Quitar
          </Button>

          <Button variant="secondary"
            onClick={ onEdit }
          >
            Modificar
          </Button>
        </Col>
      </Row>
    )
  }
}


export default ComplementoSummaryActionButtons;